import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Loader2, Mail, Check } from 'lucide-react';
import { newsletterSignup } from '../api';
import { useToast } from '../hooks/use-toast';

export const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setSubmitting(true);
    try {
      const result = await newsletterSignup(email);
      setSubscribed(true);
      toast({ title: 'Welcome to the family! 🔥', description: result.message });
    } catch (err) {
      toast({
        title: 'Error',
        description: err.response?.data?.detail || 'Could not subscribe',
        variant: 'destructive',
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (subscribed) {
    return (
      <div className="flex items-center justify-center gap-2 text-green-400 py-3" data-testid="newsletter-subscribed">
        <Check className="h-5 w-5" />
        <span className="font-bold">You're on the list. Stay turnt.</span>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto" data-testid="newsletter-form">
      <div className="flex items-center justify-center gap-2 text-[#ff1f4d] mb-3">
        <Mail className="h-5 w-5" />
        <span className="uppercase text-sm tracking-[3px] font-bold">Get the Drop First</span>
      </div>
      <p className="text-gray-400 text-sm mb-4">
        Subscribe for early access to new releases & exclusive codes
      </p>
      <form onSubmit={handleSubmit} className="flex gap-2">
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          required
          className="bg-black border-[#222] text-white"
          data-testid="newsletter-email-input"
        />
        <Button
          type="submit"
          disabled={submitting}
          className="bg-[#ff1f4d] hover:bg-white hover:text-black font-bold disabled:opacity-50"
          data-testid="newsletter-submit-btn"
        >
          {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : 'JOIN'}
        </Button>
      </form>
    </div>
  );
};
